// components/dashboard/TrafficSources.tsx
"use client";

import { Search, Share2, Target, Link2, LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

const ICON_MAP: Record<string, LucideIcon> = {
  "جستجوی گوگل": Search,
  "شبکه‌های اجتماعی": Share2,
  "تبلیغات مستقیم": Target,
  "ورودی مستقیم": Link2,
};

interface TrafficSourcesProps {
  sources: any[];
}

export function TrafficSources({ sources }: TrafficSourcesProps) {
  return (
    <div className="materio-card h-full flex flex-col">
      <div className="p-5 pb-2">
        <h3 className="text-base font-bold text-foreground">منابع ترافیک</h3>
        <p className="text-xs text-muted-foreground mt-1">منبع ورودی کاربران</p>
      </div>
      <div className="p-5 pt-3 flex-1">
        <div className="space-y-5">
          {sources.map((source) => {
            const Icon = ICON_MAP[source.source] || Link2;
            return (
              <div key={source.source}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <div className={cn("w-2.5 h-2.5 rounded-full shrink-0", source.color)} />
                    <Icon className="h-4 w-4 text-muted-foreground shrink-0" />
                    <span className="text-sm font-medium text-foreground">{source.source}</span>
                  </div>
                  <span className="text-sm font-bold text-foreground">{source.percentage}٪</span>
                </div>
                <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden">
                  <div
                    className={cn("h-full rounded-full transition-all duration-1000", source.color)}
                    style={{ width: `${source.percentage}%` }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}